import Vue from "vue";
import LinearScale from "linear-scale";
import Slick from "vue-slick";
import _ from "lodash";
import Photographer from "../../components/Photographer";
import AnimatedComponent from "../../components/Animated";
import "v-calendar/src/styles/base.css";
import { DatePicker } from "v-calendar";
import { StripePlugin } from "@vue-stripe/vue-stripe";

let els;

if ((els = document.querySelectorAll(".book-steps")).length > 0) {
  let MIX_STRIPE_PUBLIC_KEY = process.env.MIX_STRIPE_PUBLIC_KEY;
  Vue.use(StripePlugin, {
    pk: MIX_STRIPE_PUBLIC_KEY,
    locale: "fr",
  });

  for (let i = 0; i < els.length; i++) {
    const el = els[i];

    new Vue({
      el: el,
      name: "BookSteps",
      components: { Slick, Photographer, AnimatedComponent, DatePicker },
      data() {
        return {
          presentBook: 0,
          timeShooting: false,
          questionOne: false,
          questionTwo: false,
          opened: false,
          mpdfdate: null,
          openModal: false,
          step: 1,
          cities: [],
          timesSelect: [
            "9h",
            "9h30",
            "10h",
            "10h30",
            "11h",
            "11h30",
            "12h",
            "12h30",
            "13h",
            "13h30",
            "14h",
            "14h30",
            "15h",
            "15h30",
            "16h",
            "16h30",
            "17h",
            "17h30",
            "18h",
            "18h30",
            "19h",
          ],
          citiesSelect: [],
          currentCity: false,
          displayCalendar: "none",
          displayStudios: "none",
          displaySelectedStudio: "none",
          displayModal: "none",
          currentStudio: false,
          selectedStudio: false,
          windowWidth: window.innerWidth,
          showSlick: true,
          convert_coords: window.ConvertCoords,
          slickOptions: {
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
          },
          markersSizes: {
            1: "w-9",
            2: "w-12",
            3: "w-16",
          },
          markersActiveSizes: {
            1: "w-16",
            2: "w-20",
            3: "w-24",
          },
          cities: [],
          selectedFaq: null,
          opened: false,
          heights: {},
          colors: [
            "text-default-300",
            "text-default-500",
            "text-default-200",
            "text-default-400",
            "text-default-600",
          ],
          questions: window.passdata.template.faq.questions,
          time: 1100,
          current_step: 0,
          steps: window.passdata.template.howItsWork,
          disableBTN: false,
          bookClasses: " noActive ",
          cardName: null,
          token: null,
          cardNumber: null,
          cardExpiry: null,
          cardCvc: null,
          textRecapTitle: "Une séance photo en famille",
          modelConfig: {
            type: "string",
            mask: "DD/MM/YYYY",
          },
          selectedStudioID: null,
          selectedDate: null,
          selectedStudioName: null,
          selectedTime: null,
        };
      },
      computed: {
        studiosList: function () {
          this.currentStudio = this.currentCity.studios[0];
          if (this.$refs.slick) {
            this.$nextTick(() => {
              this.$refs.slick.reSlick();
            });
          }
          return this.currentCity.studios;
        },
        textQuestionOneYes() {
          if (this.selectedStudio) {
            return "Je souhaite changer de studio photos";
          } else if (this.presentBook == 1) {
            return "Oui, je veux choisir le studio photos maintenant";
          } else {
            return "Oui, je veux choisir mon studio photos maintenant";
          }
        },
        textQuestionOneNo() {
          if (this.selectedStudio && this.presentBook == 1) {
            return "Je préfère finalement laisser le destinataire du cadeau choisir le studio photos";
          } else if (this.selectedStudio) {
            return "Je préfère finalement choisir mon studio photo plus tard";
          } else if (this.presentBook == 1) {
            return "Non, je laisserai le destinataire du cadeau choisir le studio photos";
          } else {
            return "Non, je prendrai le temps de découvrir les studios partenaires plus tard";
          }
        },
        textQuestionTwoNo() {
          if (this.presentBook == 1) {
            return "<span class='font-semibold'>Je laisserai le destinataire du cadeau décider de la date plus tard </span>(aucune urgence, il disposera d’un an à compter de la date d'achat pour utiliser son bon de réservation)";
          } else {
            return "<span class='font-semibold'>Je déciderai de la date plus tard </span>(aucune urgence, vous disposez d’un an à compter de la date d'achat pour utiliser votre bon de réservation)";
          }
        },
        titleQuestionOne() {
          if (this.presentBook == 1) {
            return "Souhaitez-vous choisir le studio photos dès à présent ?";
          } else {
            return "Souhaitez-vous choisir votre studio photos dès à présent ?";
          }
        },
        titleQuestionTwo() {
          if (this.presentBook == 1) {
            return "Voulez-vous sélectionner une date pour la séance photo ?";
          } else {
            return "Quand souhaitez-vous réaliser votre portrait de famille ?";
          }
        },
        stripeElements() {
          return this.$stripe.elements();
        },
      },
      watch: {
        questionOne(newValue, oldValue) {
          if (newValue === "false") {
            this.selectedStudio = false;
            this.scrollToResult();
          }

          if (oldValue === 99 && newValue === "true") {
            this.selectedStudio = false;
            this.scrollToResult();
          }

          if (newValue === "true") {
            this.displayStudios = "block";
          }
        },
        questionTwo(newValue, oldValue) {
          if (newValue === "true") {
            this.displayCalendar = "block";
            this.mpdfdate = new Date().toLocaleDateString("fr-FR", {
              day: "numeric",
              month: "numeric",
              year: "numeric",
            });
          } else {
            this.mpdfdate = null;
          }
        },
      },
      methods: {
        getImage: window.getImage,
        slickNext() {
          this.$refs.slick.next();
          let currIndex = this.$refs.slick.currentSlide();
          this.currentStudio = this.studiosList[currIndex];
        },
        validateData() {
          if (this.mpdfdate == null) {
            this.timeShooting = false;
            alert(
              "Vous devez sélectionner une date avant de choisir l'horaire de votre séance photo en famille !"
            );
          }
        },
        textRecap() {
          var text = "Une séance photo en famille";
          var selectedStudioName = localStorage.getItem("selectedStudioName");
          var selectedDate = localStorage.getItem("selectedDate");
          var selectedTime = localStorage.getItem("selectedTime");

          if (
            selectedStudioName != null &&
            selectedStudioName != null &&
            selectedStudioName != false &&
            selectedStudioName != "undefined"
          ) {
            text = text + " avec " + selectedStudioName;
          }

          if (
            selectedDate !== "null" &&
            selectedDate !== null &&
            selectedDate !== false &&
            selectedDate !== "undefined"
          ) {
            text = text + " le " + selectedDate;
          }

          if (
            selectedDate !== "null" &&
            selectedDate != null &&
            selectedDate != false &&
            selectedTime != "null" &&
            selectedTime != null &&
            selectedTime != false &&
            selectedTime != "false"
          ) {
            text = text + " à " + selectedTime;
          }
          this.textRecapTitle = text;
        },
        slickPrev() {
          this.$refs.slick.prev();
          let currIndex = this.$refs.slick.currentSlide();
          this.currentStudio = this.studiosList[currIndex];
        },
        selectStudio(studio) {
          this.showSlick = false;

          this.currentStudio = studio;

          this.$nextTick(function () {
            this.$nextTick(function () {
              this.showSlick = true;
            });
          });
        },
        selectCity(city) {
          if (this.$refs.slick) {
            this.$nextTick(() => {
              this.$refs.slick.reSlick();
            });
          }

          if (city !== false) {
            this.currentCity = city;
            if (
              (this.studiosList.length > 0 && this.windowWidth > 767) ||
              this.studiosList.length === 1
            ) {
              this.currentStudio = this.studiosList[0];
              this.selectStudio(this.studiosList[0]);
              if (this.$refs.slick) {
                this.$nextTick(() => {
                  this.$refs.slick.reSlick();
                });
              }
            }
          }
        },
        selectStudioAction(studio) {
          // localStorage.setItem('selectedStudioObject', studio);
          this.selectedStudio = studio;
          this.displaySelectedStudio = "block";
          this.questionOne = 99;
          this.currentCity = false;
          this.scrollToResultQ2();
        },
        isCurrentStudio(studio) {
          return this.currentStudio && studio.id === this.currentStudio.id;
        },
        isCurrentCity(city) {
          return this.currentCity && city.id === this.currentCity.id;
        },
        getMarkerSize(size, active) {
          if (typeof active !== "undefined")
            return this.markersActiveSizes[size];
          else return this.markersSizes[size];
        },
        getMarkerStyle(coords) {
          const position = this.coordsToPost(coords);

          return {
            top: position.y + "%",
            left: position.x + "%",
          };
        },
        findNearest(coords) {
          let nearestCity;
          let newDistance;
          let nearestDistance = 1000000000;

          this.citiesSelect.forEach((city) => {
            if (
              typeof nearestDistance === "undefined" ||
              (newDistance = this.getDistance(city.coords, coords)) <
                nearestDistance
            ) {
              nearestDistance = newDistance;
              nearestCity = city;
            }
          });
          if (nearestCity) {
            this.selectCity(nearestCity);
          }
        },
        getDistance(coords1, coords2) {
          var point1 = new google.maps.LatLng(coords1.lat, coords1.lng);
          var point2 = new google.maps.LatLng(coords2.lat, coords2.lng);

          var distance = google.maps.geometry.spherical.computeDistanceBetween(
            point1,
            point2
          );
          return distance / 1000;
        },
        getDistance2(coords1, coords2) {
          const radLat1 = (Math.PI * coords1.lat) / 180;
          const radLat2 = (Math.PI * coords2.lat) / 180;
          const theta = coords1.lng - coords2.lng;
          const radTheta = (Math.PI * theta) / 180;

          let dist =
            Math.sin(radLat1) * Math.sin(radLat2) +
            Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta);

          if (dist > 1) dist = 1;

          dist = Math.acos(dist);
          dist = (dist * 180) / Math.PI;
          dist = dist * 60 * 1.1515;

          return dist;
        },
        getClickPos(event) {
          const pos = {
            x: (event.offsetX / 568) * 100,
            y: (event.offsetY / 576) * 100,
          };
        },
        posToCoords(coords) {
          const ScalerLatY = LinearScale(
            [this.convert_coords.pos0.y, this.convert_coords.pos1.y],
            [
              this.latToY(this.convert_coords.pos0.lat),
              this.latToY(this.convert_coords.pos1.lat),
            ]
          );
          const ScalerLngX = LinearScale(
            [this.convert_coords.pos0.x, this.convert_coords.pos1.x],
            [this.convert_coords.pos0.lng, this.convert_coords.pos1.lng]
          );

          return {
            lat: this.yToLat(ScalerLatY(coords.y)),
            lng: ScalerLngX(coords.x),
          };
        },
        coordsToPost(LatLng) {
          const ScalerLngY = LinearScale(
            [
              this.latToY(this.convert_coords.pos0.lat),
              this.latToY(this.convert_coords.pos1.lat),
            ],
            [this.convert_coords.pos0.y, this.convert_coords.pos1.y]
          );
          const ScalerLatX = LinearScale(
            [this.convert_coords.pos0.lng, this.convert_coords.pos1.lng],
            [this.convert_coords.pos0.x, this.convert_coords.pos1.x]
          );

          return {
            y: ScalerLngY(this.latToY(LatLng.lat)),
            x: ScalerLatX(LatLng.lng),
          };
        },
        latToY(lat) {
          return this.rad2deg(Math.asinh(Math.tan(this.deg2rad(lat))));
        },
        yToLat(y) {
          return this.rad2deg(Math.atan(Math.sinh(this.deg2rad(y))));
        },
        deg2rad(degrees) {
          var pi = Math.PI;
          return degrees * (pi / (180 * 1.5));
        },
        rad2deg(radians) {
          var pi = Math.PI;
          return radians * ((180 * 1.5) / pi);
        },
        reviews() {
          this.openModal = true;
          this.displayModal = "block";
        },
        closeModal() {
          this.openModal = false;
          this.displayModal = "none";
        },
        scrollToResult() {
          const element = document.getElementById("book-steps-id");
          if (typeof element !== null && element !== "undefined") {
            window.scrollTo({
              top: element.offsetTop - 180,
              left: 0,
              behavior: "smooth",
            });
          }
        },
        scrollToResultQ2() {
          const element = document.getElementById("book-steps1-q2");
          // console.log(element.offsetTop);
          if (typeof element !== null && element !== "undefined") {
            window.scrollTo({
              top: element.offsetTop + 350,
              left: 0,
              behavior: "smooth",
            });
          }
        },
        answerHeight(question, index) {
          return this.opened === index ? "100%" : 0;
        },
        selectFaq(index) {
          if (this.selectedFaq === index) {
            this.selectedFaq = null;
          } else {
            this.selectedFaq = index;
          }
        },
        nextStep() {
          if (this.current_step === 5) this.current_step = 0;
          else this.current_step += 1;

          setTimeout(this.nextStep, this.time);
        },
        // setBookingStep(step) {
        //     localStorage.setItem('booking-step', step);
        //     this.step = step;
        // },
        resetSteps() {
          localStorage.removeItem("presentBook");
          localStorage.removeItem("booking-step");
          localStorage.removeItem("selectedStudioID");
          localStorage.removeItem("selectedDate");
          localStorage.removeItem("selectedTime");
          localStorage.removeItem("booking-selectedcity");
          localStorage.removeItem("booking-selected-city");
          localStorage.removeItem("booking-selected-studio");
          localStorage.removeItem("selectedStudioName");
        },
        // goToStep(step) {
        //     if (this.step >= step) {
        //         this.step = step;
        //     }
        // },
        saveStudio() {
          this.step = 2;
          localStorage.setItem("selectedStudioName", this.selectedStudio.name);
          localStorage.setItem("selectedStudioID", this.selectedStudio.id);
          localStorage.setItem("selectedDate", this.mpdfdate);
          localStorage.setItem("selectedTime", this.timeShooting);
          this.textRecap();
          this.scrollToResult();
          this.selectedStudioID = localStorage.getItem("selectedStudioID");
          this.selectedDate = localStorage.getItem("selectedDate");
          this.selectedStudioName = localStorage.getItem("selectedStudioName");
          this.selectedTime = localStorage.getItem("selectedTime");
        },
        createToken(event, StripeToken) {
          // localStorage.removeItem('selectedStudioID');
          // localStorage.removeItem('selectedDate');
          // localStorage.removeItem('selectedTime');
          // localStorage.removeItem('booking-step');
          // localStorage.removeItem('booking-selectedcity');
          // localStorage.removeItem('booking-selected-city');
          // localStorage.removeItem('booking-selected-studio');

          this.bookClasses = " active ";
          this.disableBTN = true;

          if (StripeToken !== null) return;

          event.preventDefault();
          const stripeIntent = window.passdata.stripe_intent;

          this.$stripe
            .confirmCardPayment(stripeIntent.client_secret, {
              payment_method: {
                card: this.cardNumber,
              },
            })
            .then((result) => {
              if (result.error) {
                console.log(result.error.message);
              } else {
                this.token = result.paymentIntent.id;
                this.resetSteps();
                this.$nextTick(() => {
                  this.$refs.StripeForm.submit();
                });
              }
            });
        },
      },
      created() {
        this.cities = window.passdata.citiesSelect;
        this.citiesSelect = window.passdata.citiesSelect;

        var presentBook = localStorage.getItem("presentBook");
        if (presentBook) {
          this.presentBook = presentBook;
          localStorage.removeItem("presentBook");
        }
      },
      mounted() {
        window.onresize = () => {
          this.windowWidth = window.innerWidth;
        };

        // this.$refs.answers.forEach((answer, index) => {
        //     this.heights[index] = answer.getBoundingClientRect().height;
        //     this.questions[index].init = true;
        // })

        this.$nextTick(() => {
          this.opened = 0;
        });

        setTimeout(this.nextStep, this.time);

        this.bookClasses = " noActive ";
        this.disableBTN = false;
        const style = {
          base: {
            color: "#263232",
            fontFamily: '"Poppins", sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "12px",
            "::placeholder": {
              color: "#263232",
            },
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
          },
        };
        this.cardNumber = this.stripeElements.create("cardNumber", {
          style,
          placeholder: "Numéro de la carte *",
        });
        this.cardNumber.mount("#card-number");
        this.cardExpiry = this.stripeElements.create("cardExpiry", {
          style,
          placeholder: "Date d'expiration *",
        });
        this.cardExpiry.mount("#card-expiry");
        this.cardCvc = this.stripeElements.create("cardCvc", {
          style,
          placeholder: "CVC *",
        });
        this.cardCvc.mount("#card-cvc");

        var bookSelectedCity = localStorage.getItem("booking-selectedcity");

        if (bookSelectedCity != null && bookSelectedCity != "") {
          this.questionOne = "true";
          this.selectedStudio = false;
          this.currentCity = _.find(
            this.cities,
            (city, index) => city.slug === bookSelectedCity
          );
          localStorage.removeItem("booking-selectedcity");
        }

        var bookingSelectedCity = localStorage.getItem("booking-selected-city");
        var bookingSelectedStudio = localStorage.getItem(
          "booking-selected-studio"
        );

        if (bookingSelectedCity != null && bookingSelectedStudio != null) {
          this.questionOne = 99;
          this.currentCity = _.find(
            this.cities,
            (city, index) => city.slug == bookingSelectedCity
          );
          this.selectedStudio = _.find(
            this.currentCity.studios,
            (studio, index) => studio.id == bookingSelectedStudio
          );
          this.displaySelectedStudio = "block";
          // localStorage.setItem('selectedStudioObject', this.selectedStudio);
          localStorage.removeItem("booking-selected-city");
          localStorage.removeItem("booking-selected-studio");
          this.currentCity = false;
        }

        // var bookingStep = localStorage.getItem('booking-step');
        // if (bookingStep != null && bookingStep != null) {
        //     this.step = bookingStep;
        // }

        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        if (params.get("step")) {
          this.step = params.get("step");
        }

        // var selectedTime = localStorage.getItem('selectedTime');
        // if (selectedTime) {
        //     this.timeShooting = selectedTime;
        // }

        // var selectedDate = localStorage.getItem('selectedDate');
        // if (selectedDate) {
        //     this.mpdfdate = selectedDate;
        // }

        // var selectedStudioObject = localStorage.getItem('selectedStudioObject');
        // if (selectedStudioObject) {
        //     this.selectedStudio = selectedStudioObject;
        //     console.log(this.selectedStudio);
        // }

        var selectedStudioID = localStorage.getItem("selectedStudioID");
        if (selectedStudioID) {
          this.selectedStudioID = selectedStudioID;
        }

        var selectedDate = localStorage.getItem("selectedDate");
        if (selectedDate) {
          this.selectedDate = selectedDate;
        }

        var selectedStudioName = localStorage.getItem("selectedStudioName");
        if (selectedStudioName) {
          this.selectedStudioName = selectedStudioName;
        }

        var selectedTime = localStorage.getItem("selectedTime");
        if (selectedTime) {
          this.selectedTime = selectedTime;
        }

        this.textRecap();
      },
      beforeMount() {
        if (window.passdata.city_slug) {
          this.currentCity = _.find(
            this.cities,
            (city, index) => city.slug === window.passdata.city_slug
          );
        }
      },
      beforeUnmount() {
        localStorage.removeItem("presentBook");
        this.presentBook = 0;
      },
      beforeDestroy() {
        this.presentBook = 0;
        this.cardNumber.destroy();
        this.cardExpiry.destroy();
        this.cardCvc.destroy();

        // delete data from localstorage
        this.resetSteps();
      },
    });
  }
}
